"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.role = exports.brand = exports.customerOverview = exports.customer = exports.user = exports.feeTypes = exports.settlementTotals = exports.settlementsPending = exports.settlementsReady = exports.serviceCategories = exports.operators = exports.customerOverviews = exports.users = exports.roles = exports.productTypes = exports.permissions = exports.countries = exports.channels = exports.brands = void 0;
const brands_1 = __importDefault(require("./mockData/brands"));
exports.brands = brands_1.default;
const channels_1 = __importDefault(require("./mockData/channels"));
exports.channels = channels_1.default;
const countries_1 = __importDefault(require("./mockData/countries"));
exports.countries = countries_1.default;
const customerOverviews_1 = __importDefault(require("./mockData/customerOverviews"));
exports.customerOverviews = customerOverviews_1.default;
const customers_1 = __importDefault(require("./mockData/customers"));
const feeTypes_1 = __importDefault(require("./mockData/feeTypes"));
exports.feeTypes = feeTypes_1.default;
const operators_1 = __importDefault(require("./mockData/operators"));
exports.operators = operators_1.default;
const permissions_1 = __importDefault(require("./mockData/permissions"));
exports.permissions = permissions_1.default;
const productTypes_1 = __importDefault(require("./mockData/productTypes"));
exports.productTypes = productTypes_1.default;
const roles_1 = __importDefault(require("./mockData/roles"));
exports.roles = roles_1.default;
const serviceCategories_1 = __importDefault(require("./mockData/serviceCategories"));
exports.serviceCategories = serviceCategories_1.default;
const settlementTotals_1 = __importDefault(require("./mockData/settlementTotals"));
exports.settlementTotals = settlementTotals_1.default;
const settlementsPending_1 = __importDefault(require("./mockData/settlementsPending"));
exports.settlementsPending = settlementsPending_1.default;
const settlementsReady_1 = __importDefault(require("./mockData/settlementsReady"));
exports.settlementsReady = settlementsReady_1.default;
const users_1 = __importDefault(require("./mockData/users"));
exports.users = users_1.default;
const user = (userId) => users_1.default.find((user) => user.id === userId);
exports.user = user;
const customer = (customerId) => customers_1.default.find((customer) => customer.id === customerId);
exports.customer = customer;
const customerOverview = (customerId) => customerOverviews_1.default.find((customerOverview) => customerOverview.id === customerId);
exports.customerOverview = customerOverview;
const brand = (brandId) => brands_1.default.find((brand) => brand.id === brandId);
exports.brand = brand;
const role = (id) => roles_1.default.find((role) => role.id === id);
exports.role = role;
